import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./css/noticias.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import moment from "moment";
import {Server} from "../../constants";
import { LazyLoadImage } from "react-lazy-load-image-component";

function ListadoNoticias(props) {
  const [noticias, setNoticias] = useState([]);
  const httpsRegex = new RegExp("^http[s]?://");

  useEffect(() => {
    // Get Noticias
    const getNoticias = async () => {
      const url = `${Server}/api/obtener_noticias_pagina/1`;
      const resultado = await axios.get(url);
      setNoticias(resultado.data);
    };
    getNoticias();
  }, []);

  const tipoUrl = (noticia) => {
    if (httpsRegex.test(noticia.NOT_URL)) {
      return (
        <Link
          className="text-decoration-none"
          onClick={(event) => {
            window.open(noticia.NOT_URL, "_blank");
          }}
        >
          <LazyLoadImage
            src={noticia.NOT_URL_IMAGEN}
            alt="Hyundai"
            effect="blur"
            width={300}
            height={200}
          />
          <p className="press-date mt-2 mt-md-4">
            {moment(noticia.NOT_FECHA).format("DD/MM/YYYY")}
          </p>
          <h3 className="press-article">{noticia.NOT_TITULO}</h3>
          <p className="read-more-article">Leer más</p>
        </Link>
      );
    } else {
      return (
        <Link to={noticia.NOT_URL} className="text-decoration-none">
          <LazyLoadImage
            src={noticia.NOT_URL_IMAGEN}
            alt="Hyundai"
            effect="blur"
            width={300}
            height={200}
          />
          <p className="press-date mt-2 mt-md-4">
            {moment(noticia.NOT_FECHA).format("DD/MM/YYYY")}
          </p>
          <h3 className="press-article">{noticia.NOT_TITULO}</h3>
          <p className="read-more-article">Leer más</p>
        </Link>
      );
    }
  };

  return (
    <Fragment>
      <Container>
        <Row className="sr-only">
          <Col md={12} className="text-center mt-4 mt-md-5">
            <h1>Hyundai Noticias</h1>
          </Col>
        </Row>
        <Row>
          {noticias.map((noticia) => (
            <Col key={noticia.NOT_CODIGO} md={4} className="mt-3">
              {tipoUrl(noticia)}
            </Col>
          ))}
        </Row>
      </Container>
    </Fragment>
  );
}
export default ListadoNoticias;